/* eslint-disable no-param-reassign */
import { Q } from '@nozbe/watermelondb'

import flatMap from 'lodash/flatMap'
import map from 'lodash/map'

import { getAllMilkDeliveries } from '@smartcoop/services/apis/smartcoopApi/resources/dairyFarm'


const MILK_DELIVERIES_FIELDS = [
  'milkDeliveryId', 'dairyFarmId', 'condemnedVolume', 'manual', 'observation', 'organizationId',
  'statusId','temperature','userId','userStateRegistrationId','volume','volumeDate','status',
  'createdAt', 'updatedAt'
]

export function milkDeliveriesService(database) {
  async function createOrUpdate(milkDeliveries = []) {
    await database.write(async () => {
      const promises = milkDeliveries.map((milkDelivery) => async () => {
        const register = await database.get('milkDeliveries')
          .query(Q.where('milkDeliveryId', milkDelivery?.milkDeliveryId || milkDelivery?.id))
          .fetch()

        if(register[0]) {
          map(register, (item) => {
            item.destroyPermanently()
          })
        }
        if(milkDelivery?.deletedAt) {
          return
        }
        await database.get('milkDeliveries').create((item) => {
          MILK_DELIVERIES_FIELDS.forEach((field) => {
            if(
              field === 'status'
            ) {
              item[field] = JSON.stringify(milkDelivery[field])
            }
            if(field === 'milkDeliveryId') {
              item[field] = milkDelivery?.milkDeliveryId || milkDelivery?.id
            } else {
              item[field] = milkDelivery[field]
            }
          })
        })
      })

      await Promise.all(promises.map((fn) => fn()))
    })
  }

  async function deleteMilkDeliveryById(milkDeliveryId) {
    await database.write(async () => {
      const register = await database.get('milkDeliveries')
        .query(Q.where('milkDeliveryId', milkDeliveryId))
        .fetch()

      if (register[0]) {
        await register[0].markAsDeleted()
      }
    })
  }

  async function clearTable() {
    await database.write(async () => {
      await database.get('milkDeliveries').query().destroyAllPermanently()
    })
  }

  async function findMilkDeliveryById(milkDeliveryId) {
    return database
      .get('milkDeliveries')
      .query(Q.where('milkDeliveryId', milkDeliveryId))
      .fetchOne()
  }

  function observeMilkDeliveries(dairyFarmId = null) {
    const milkDeliveriesCollection = database.collections.get('milkDeliveries')

    return milkDeliveriesCollection.query(
      Q.where('dairyFarmId', Q.eq(dairyFarmId))
    ).observe()
  }

  async function syncMilkDeliveries(params) {
    const { data: response } = await getAllMilkDeliveries(
      { ...params, limit: 999999 }
    )

    await createOrUpdate(flatMap(response, grouped => flatMap(grouped?.data, item => ({ ...item, dairyFarmId: grouped?.dairyFarmId }))))
  }

  return {
    createOrUpdate,
    clearTable,
    deleteMilkDeliveryById,
    findMilkDeliveryById,
    observeMilkDeliveries,
    syncMilkDeliveries
  }
}